import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";
import { NotifyService } from "../services/notify-service";
import { AlertService } from "../services/alert-service";
import { EntityConfigService } from "../services/entity-config-service";
import { WorkflowConfigService } from "../services/workflow-config-service";
import { Dictionary } from "lodash";

export function RLEditAlertList() {
	var directive: ng.IDirective = {
		restrict: "AE",
		template: require("/assets/app/templates/edit-alert-list.html"),
		controller: RLEditAlertListController,
		controllerAs: "aVM",
		bindToController: true,
		scope: {
			charTypeID: "=charTypeId",
			templateID: "=templateId",
			charID: "=charId",
			charDataType: "=",
			charLabel: "="
		}
	};

	return directive;
}

class RLEditAlertListController {
	public static $inject = [
		"$scope",
		"$q",
		"notifyService",
		"alertService",
		"entityConfigService",
		"workflowConfigService"
	];

	public charTypeID: number;
	public charID: number;
	public templateID: number;
	public charDataType: number;
	public charLabel: string;

	public alertFrequencyTypes: Models.IAlertFrequency[] = [];
	public alertTimeframeTypes: Models.IAlertTimeframe[] = [];
	public alerts: Models.IAlert[] = [];

	public alertModalOpen: boolean = false;
	public emails: string[] = [];
	public newEmail: string;

	public selectedAlert: Models.IAlert = null;
	public disableQtyFrqFields: boolean = true;
	public alertNotifications: Models.IWFRoleNotification[] = [];
	public selectedAlertNotification: Models.IWFRoleNotification = undefined;
	public disableSave: boolean = false;

	public listRoles: Models.IWFActionRole[] = [];
	public selectedNotificationRoles: Models.IWFActionRole[] = [];
	public selectAllRoles: boolean = false;
	public selectAllParties: boolean = false;
	public isComponentModule: boolean = false;
	public expandRoles: boolean = false;
	public expandParties: boolean = false;
	public listParties: Models.IParty[] = [];
	public selectedNotificationParties: Models.IParty[] = [];
	public selectedNotifyChildren: { [partyID: number]: boolean } = {};
	public selectAllNotifyChildren = false;

	public otherTemplateDates: Models.ICharacteristicMetaData[] = [];
	public otherTemplateDatesLookup: Dictionary<string> = {};

	public containsOptions: Models.IAlertContainsType[];
	public containsOptionsLookup: Dictionary<string> = {};

	public constructor(private readonly $scope: ng.IScope,
		private readonly $q: ng.IQService,
		private readonly notifyService: NotifyService,
		private readonly alertService: AlertService,
		private readonly entityConfigService: EntityConfigService,
		private readonly workflowConfigService: WorkflowConfigService) {

		$scope.$watchCollection(() => [this.charTypeID, this.templateID, this.charID],
			(newValue, oldValue) => {
				if (this.charTypeID != null && this.templateID != null && this.charID != null)
					this.LoadAlerts();
			});

		$scope.$watch(() => this.newEmail, (newValue, oldValue) => {
			if (newValue != oldValue && !_.isEmpty(newValue)) {
				this.disableSave = true;
			}
		});
	}

	private LoadAlerts() {
		this.notifyService.startProgress();

		let templatePromise = this.entityConfigService.getCharacteristicTemplate(this.charTypeID, this.templateID)
			.then(result => {
				this.otherTemplateDates = result.characteristicMetaDatas
					.filter(x => x.dataTypeID === Consts.CharDataTypeIDs.CharDataTypes.date
						&& x.characteristicID !== this.charID);

				this.otherTemplateDatesLookup = this.otherTemplateDates
					.reduce<Dictionary<string>>((lookup, next) => {
						lookup[next.characteristicID] = next.label;
						return lookup;
					}, {});
			});

		let containsOptionsPromise = this.alertService.getAlertContainsValueTypeList()
			.then(result => {
				this.containsOptions = result;
				this.containsOptionsLookup = this.alertService.alertContainsValuesToLookup(result);
			});

		let promise1 = this.alertService.getConfigAlertList(this.charTypeID, this.templateID, this.charID, -1)
			.then((results) => {
				this.alerts = results;
				_.forEach(this.alerts, (al) => {
					if (_.isEmpty(al.bodyHTML)) {
						al.bodyHTML = al.body;
					}
				});
			});

		let promise2 = this.entityConfigService.getAlertNofitications(this.charTypeID, this.templateID)
			.then((response) => {
				_.each(response, (item) => {
					if (!_.any(this.alertNotifications, an => an.id == item.id)) {
						this.alertNotifications.push(item);
					}
				});
			});

		let promises = [templatePromise, containsOptionsPromise, promise1, promise2];
		return this.$q.all(promises)
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	private LoadAlertValues() {
		this.notifyService.startProgress();

		let alertFrequencyPromise = this.alertService.getAlertFrequencyList()
			.then((results) => {
				this.alertFrequencyTypes = results;
			});

		let alertTimeframePromise = this.alertService.getAlertTimeframeList()
			.then((results) => {
				this.alertTimeframeTypes = results;
			});
		var promises = [alertFrequencyPromise, alertTimeframePromise];

		return this.$q.all(promises)
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	public DeleteAlert(alert) {
		this.notifyService.startProgress();
		this.alertService.deleteAlert(alert.id)
			.then((results) => {
				this.notifyService.notifySuccess("Alert Deleted");
			})
			.finally(() => {
				this.notifyService.endProgress();
				this.LoadAlerts();
			});
	}

	public UpdateAlert() {
		this.notifyService.startProgress();
		this.selectedAlert.toEmail = this.emails.join(';');
		this.selectedAlert.selectedRoleIDs = _.map(this.selectedNotificationRoles, 'roleID').join(';');
		this.selectedAlert.selectedPartyIDs = _.map(this.selectedNotificationParties, 'partyID').join(';');
		var notifyChildren = [];
		_.forEach(this.selectedNotifyChildren, (x, key) => {
			if (x) {
				notifyChildren.push(key);
			}
		});
		this.selectedAlert.notifyChildrenPartyIds = notifyChildren.join(";");

		var promises: ng.IPromise<any>[] = [];
		if (this.selectedAlert.ID == '') {
			let createPromise = this.alertService.createAlert(this.selectedAlert)
				.then((result) => {
					this.notifyService.notifySuccess("Alert Created");
				});

			promises.push(createPromise);
		}
		else {
			let updatePromise = this.alertService.updateAlert(this.selectedAlert)
				.then((result) => {
					this.notifyService.notifySuccess("Alert Updated");
				});

			promises.push(updatePromise);
		}

		return this.$q.all(promises)
			.finally(() => {
				this.notifyService.endProgress();
				this.LoadAlerts();
				this.alertModalOpen = false;
				this.ResetFields();
			});
	}

	private BuildNotificationCheckBox() {
		this.LoadRoles();
		//Check if module
		if (Utils.CharUtil.IsModuleLevelCharType(this.charTypeID)) {
			this.LoadParties();
		}
		//Load all parties for CLA-8661
		else {
			this.LoadAllParties();
		}
	}

	private LoadAllParties() {
		this.listParties = [];
		this.entityConfigService.getParties().then((result) => {
			if (result) {
				this.listParties = result.data;
			}
			if (this.selectedAlert != null && this.selectedAlert.selectedPartyIDs != null) {
				this.selectedNotificationParties = [];
				let selectedPartyIDs = this.selectedAlert.selectedPartyIDs.split(";");
				_.forEach(selectedPartyIDs,
					(p) => {
						let selectedParty = _.filter(this.listParties, party => party.partyID.toString() == p)
						if (selectedParty.length == 1) {
							this.selectedNotificationParties.push(selectedParty[0]);
						}
					});
				let notifyChildren = this.selectedAlert.notifyChildrenPartyIds.split(";");
				_.forEach(notifyChildren, (p) => {
					this.selectedNotifyChildren[p] = true;
				});
			}
		});
	}

	private LoadParties() {
		this.listParties = [];
		this.entityConfigService.getTemplateParties(this.charTypeID, this.templateID).then((result) => {
			if (result) {
				let filteredParties = _.filter(result, (party: Models.IParty) => party.visibilityIndicator >= 1);
				_.forEach(filteredParties, (fp) => {
					this.listParties.push(fp);
				});
				if (this.selectedAlert != null && this.selectedAlert.selectedPartyIDs != null) {
					this.selectedNotificationParties = [];
					let selectedPartyIDs = this.selectedAlert.selectedPartyIDs.split(";");
					let notifyChildrenPartyIDs = this.selectedAlert.notifyChildrenPartyIds ? this.selectedAlert.notifyChildrenPartyIds.split(";") : [];
					_.forEach(selectedPartyIDs,
						(p) => {
							let selectedParty = _.filter(this.listParties, party => party.partyID.toString() == p)
							if (selectedParty.length == 1) {
								this.selectedNotificationParties.push(selectedParty[0]);
								if (notifyChildrenPartyIDs.indexOf(selectedParty[0].partyID.toString()) > -1) {
									this.selectedNotifyChildren[selectedParty[0].partyID] = true;
								}
							}
						});
				}
			}
		});
	}

	private ToggleAllParties() {
		this.selectedNotificationParties = [];
		if (this.selectAllParties) {
			this.selectedNotificationParties = this.selectedNotificationParties.concat(this.listParties);
		}
	}

	private ToggleParty(party: Models.IParty) {
		//Check if party is already selected and if so remove
		if (_.filter(this.selectedNotificationParties, p => p.partyID == party.partyID).length == 1) {
			var partyRemoveIndex = _.indexOf(this.selectedNotificationParties, _.filter(this.selectedNotificationParties, p => p.partyID == party.partyID)[0]);
			this.selectedNotificationParties.splice(partyRemoveIndex, 1);
		}
		//Add it otherwise
		else {
			this.selectedNotificationParties.push(party);
		}
	}

	public ToggleNotifyChildren(pty: Models.IParty) {
		this.selectAllNotifyChildren = this.selectedNotifyChildren[pty.partyID];
	}

	public ToggleAllNotifyChildren() {
		var firstToggled = this.selectedNotifyChildren[this.selectedNotificationParties[0].partyID];
		_.forEach(this.selectedNotificationParties, (pty) => {
			this.selectedNotifyChildren[pty.partyID] = !firstToggled;
		});
	}

	private ToggleExpandParties() {
		this.expandParties = !this.expandParties;
	}

	private ToggleExpandRoles() {
		this.expandRoles = !this.expandRoles;
	}

	private LoadRoles() {
		this.workflowConfigService.getRoles()
			.then((result) => {
				this.listRoles = result;
				//Load already selected roles and select them visually
				if (this.selectedAlert != null && this.selectedAlert.selectedRoleIDs != null) {
					this.selectedNotificationRoles = [];
					let selectedRoleIDs = this.selectedAlert.selectedRoleIDs.split(";");
					_.forEach(selectedRoleIDs,
						(r) => {
							let selectedRole = _.filter(this.listRoles, role => role.roleID.toString() == r)
							if (selectedRole.length == 1) {
								this.selectedNotificationRoles.push(selectedRole[0]);
							}
						});
				}
			});
	}

	public ToggleAllRoles() {
		this.selectedNotificationRoles = [];
		if (this.selectAllRoles) {
			this.selectedNotificationRoles = this.selectedNotificationRoles.concat(this.listRoles);
		}
	}

	public ToggleRole(role: Models.IWFActionRole) {
		//Check if role is already selected and if so remove
		if (_.filter(this.selectedNotificationRoles, r => r.roleID == role.roleID).length == 1) {
			var roleRemoveIndex = _.indexOf(this.selectedNotificationRoles, _.filter(this.selectedNotificationRoles, r => r.roleID == role.roleID)[0]);
			this.selectedNotificationRoles.splice(roleRemoveIndex, 1);
		}
		//Add it otherwise
		else {
			this.selectedNotificationRoles.push(role);
		}
	}

	public NewAlertModal(selectedAlertNotification: Models.IWFRoleNotification) {
		this.disableSave = false;
		this.disableQtyFrqFields = true;
		this.BuildNotificationCheckBox();
		this.LoadAlertValues()
			.then(() => {
				this.selectedAlert = {
					divisionID: null,
					charTypeID: this.charTypeID,
					templateID: this.templateID,
					charID: this.charID,
					recordID: null,
					ID: '',
					fromID: null,
					body: "",
					attachment: "",
					sequenceNumber: null,
					createdBy: null,
					createdAt: "",
					updatedBy: null,
					updatedAt: "",
					status: "",
					processID: null,
					messageID: null,
					label: "",
					quantity: 0,
					frequencyID: 1,
					frequencyLabel: _.find(this.alertFrequencyTypes, f => f.frequencyID == 1).frequencyLabel,
					timeframeID: 1,
					timeframeLabel: _.find(this.alertTimeframeTypes, t => t.timeframeID == 1).timeframeLabel,
					selectedPartyIDs: "",
					selectedRoleIDs: "",
					subject: selectedAlertNotification == undefined ? "Rightsline Date Alert " : selectedAlertNotification.subject,
					bodyHTML: selectedAlertNotification == undefined ? "" : selectedAlertNotification.bodyHTML, toEmail: "",
					alertWhenSetOrUpdated: true,
					createCustomAlert: false,
					createEmailInvite: false,
					emailInviteUID: null,
					emailUpdateSequence: 0,
					templateDateCharId: null,
					templateDateContainsType: null,
					doNotSendIfRecordInactive: false,
					triggerSNSOrSQS: false,
					notifyChildrenPartyIds: ""
				};
				this.AddNewEmail(Consts.userEmail);
				this.alertModalOpen = true;
			});
	}

	public EditAlertModal(alert) {
		this.disableSave = false;
		this.LoadAlertValues();
		this.selectedAlert = _.clone(alert);
		this.emails = this.selectedAlert.toEmail.split(";");
		this.BuildNotificationCheckBox();
		//See if the emails are empty
		if (this.emails.length == 1 && this.emails[0] == "") {
			this.emails = [];
		}
		this.CheckTimeframe(alert.timeframeID);
		this.alertModalOpen = true;
	}

	public CheckTimeframe(timeFrameID) {
		if (timeFrameID == 2 || this.selectedAlert.alertWhenSetOrUpdated) {
			//Disable Quantity and Frequency
			this.disableQtyFrqFields = true;
		}
		else {
			this.disableQtyFrqFields = false;
		}
	}

	public setInput(manualinput,amt){
		this.selectedAlert.alertWhenSetOrUpdated = !manualinput;
		this.selectedAlert.createCustomAlert = manualinput;
		this.disableQtyFrqFields = !manualinput;
		if(!manualinput)
			this.selectedAlert.quantity = 0;
		else
			this.selectedAlert.quantity = amt;
	}

	public CancelAlert() {
		this.ResetFields();
	}

	public AddNewEmail(email) {
		if (!email || email == '') return;
		this.emails = _.union(this.emails, [email])  // prevents duplicates
		this.newEmail = '';
		this.disableSave = false;
	}

	public RemoveEmail(email) {
		var index = this.emails.indexOf(email);
		this.emails.splice(index, 1);
	}

	private ResetFields() {
		this.disableQtyFrqFields = false;
		this.emails = [];
		this.newEmail = "";
	}

	public SelectFirstTemplateDate() {
		if (_.any(this.otherTemplateDates)) {
			this.selectedAlert.templateDateCharId = _.first(this.otherTemplateDates).characteristicID;
			this.selectedAlert.templateDateContainsType = _.first(this.containsOptions).value;
		}
	}

	public RemoveSelectedTemplateDate() {
		this.selectedAlert.templateDateCharId = null;
		this.selectedAlert.templateDateContainsType = null;
	}
}